import { useCallback, useContext } from "react";
import { Adapt, Sheet } from "tamagui";

import { Dialog } from "./Dialog";
import { LayoutContext } from "./LayoutProvider";

export default function ModalHost() {
  const {
    ModalContent: Content,
    modalOpen: open,
    setModalContent,
    modalOptions,
  } = useContext(LayoutContext);

  const onClose = useCallback(() => {
    setModalContent(null);
  }, [setModalContent]);
  const desktopWidth = modalOptions.width ?? 728;
  const desktopHeight = modalOptions.height ?? 600;
  const dismissOnOverlayPress = modalOptions.dismissOnOverlayPress ?? false;

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
      modal
      disableRemoveScroll
    >
      <Dialog.Adapt when="maxLg">
        <Sheet
          modal
          snapPoints={[98]}
          disableDrag
          dismissOnSnapToBottom={false}
          dismissOnOverlayPress={dismissOnOverlayPress}
        >
          <Sheet.Frame backgroundColor="$backgroundGround" flex={1}>
            <Adapt.Contents />
          </Sheet.Frame>
          <Sheet.Overlay
            transition="standard"
            backgroundColor="$fillOverlay"
            backdropFilter="blur(8px)"
            enterStyle={{ opacity: 0 }}
            exitStyle={{ opacity: 0 }}
          />
        </Sheet>
      </Dialog.Adapt>

      <Dialog.Portal>
        <Dialog.Overlay
          key="overlay"
          backgroundColor="$fillOverlay"
          backdropFilter="blur(8px)"
        />
        <Dialog.FocusScope key="content" trapped loop>
          <Dialog.Content
            backgroundColor="$backgroundGround"
            flexDirection="column"
            padding={0}
            minWidth="100%"
            onPointerDownOutside={(event: { preventDefault: () => void }) => {
              if (!dismissOnOverlayPress) event.preventDefault();
            }}
            $lg={{
              minWidth: 0,
              width: desktopWidth,
              height: desktopHeight,
              maxHeight: "90vh",
              borderRadius: "$150",
              overflow: "hidden",
            }}
          >
            {!!Content && <Content onClose={onClose} />}
          </Dialog.Content>
        </Dialog.FocusScope>
      </Dialog.Portal>
    </Dialog>
  );
}
